exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sum_text.tab-content{background: #ffffff;padding:10px;}\n", ""]);

// exports
